module.exports = __webpack_public_path__ + "img/img005.e405d5b3.png";